import {createReducer, on} from '@ngrx/store';
import {RegistrationActions} from '@store/registration/registration.actions';
import {OPACRegistrationValue} from '@store/registration/registration.types';
import {FALLBACK_REGISTRATION_VALUE} from '@store/registration/registration.fallback';
import {deduplicate} from '@aviary/store/transformation.helpers';

export interface RegistrationState {
  registration: {
    completedSteps: string[],
    cardNumber: string,
    PIN: string,
    email: string,
    verificationExpired: boolean,
    value: OPACRegistrationValue
  };
  emailValidation: {
    isAvailable: boolean | 'UNKNOWN'
  };
}

export const INITIAL_REGISTRATION_STATE: RegistrationState = {
  registration: {
    completedSteps: [],
    email: '',
    verificationExpired: false,
    cardNumber: '',
    PIN: '',
    value: FALLBACK_REGISTRATION_VALUE
  },
  emailValidation: {
    isAvailable: 'UNKNOWN'
  },
};

export const registrationState = createReducer(
  INITIAL_REGISTRATION_STATE,

  on(RegistrationActions.validatePatronEmailAvailable, state => ({
    ...state,
    emailValidation: {
      isAvailable: 'UNKNOWN' as const
    }
  })),
  on(RegistrationActions.validatePatronEmailAvailableSuccess, (state, {isAvailable}) => ({
    ...state,
    emailValidation: {
      isAvailable
    }
  })),
  on(RegistrationActions.lookupAccountSuccess, (state, {cardNumber, PIN, patron}) => ({
    ...state,
    registration: {
      ...state.registration,
      email: patron.email,
      cardNumber,
      PIN,
      value: {
        ...state.registration.value,
        firstName: patron.firstName,
        lastName: patron.lastName,
        address: patron.address,
        city: patron.city,
        state: patron.state,
        zip: patron.zipCode,
        dateOfBirth: patron.dateOfBirth
      }
    }
  })),

  on(RegistrationActions.updateRegistration, (state, {value}) => ({
    ...state,
    registration: {
      ...state.registration,
      value: {
        ...state.registration.value,
        ...value
      }
    }
  })),
  on(RegistrationActions.completeRegistrationStep, (state, {step}) => ({
    ...state,
    registration: {
      ...state.registration,
      completedSteps: deduplicate([
        ...state.registration.completedSteps,
        step
      ])
    }
  })),
  on(RegistrationActions.setVerificationExpired, (state, {isExpired}) => ({
    ...state,
    registration: {
      ...state.registration,
      verificationExpired: isExpired
    }
  })),
  on(RegistrationActions.requestVerificationEmailSuccess, (state, {email, verificationUUID}) => ({
    ...state,
    registration: {
      ...state.registration,
      email,
      value: {
        ...state.registration.value,
        verificationUUID
      }
    }
  })),
);
